jQuery_T4NT(document).ready(function($) {

	/**
	 *  Variant selection changed
	 *  data-variant-toggle="{{ variant.id }}"
	 */
	// $( document ).on( "variant:changed", function( evt ) {
	//      console.log( evt.currentVariant );
	//      $('[data-variant-toggle]').hide(0);
	//      $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	// });



	function autoResponsive() {
		const width = document.body.clientWidth || window.innerWidth;
		
		if (width < 1025 && width >= 750) {
			const scale = width / 1023;
			const content = 'width=1023, initial-scale=' + scale + ', minimum-scale=' + scale + ', maximum-scale=' + scale + ', viewport-fit=cover';
			const metaViewport = document.querySelector('meta[name="viewport"]');
			if (metaViewport) {
				metaViewport.setAttribute("content", content);
			}
		}
		
		if (width < 460) {
			const scale = width / 460;
			const content = 'width=460, initial-scale=' + scale + ', minimum-scale=' + scale + ', maximum-scale=' + scale + ', viewport-fit=cover';
			const metaViewport = document.querySelector('meta[name="viewport"]');
			if (metaViewport) {
				metaViewport.setAttribute("content", content);
			}
		}
	}
	autoResponsive();

	function switchTab() {
		$(".tab-switch-wrapper .tabs-wrapper .tab").click(function() {
		  const tabId = $(this).attr('tab-i');
		  const contentWrap = $(this).closest('.tab-switch-wrapper').find('.tab-content[tab-i="' + tabId + '"]');
		  contentWrap.siblings(".tab-content").fadeOut(150).promise().done(function() {
			contentWrap.fadeIn(150);
		  });
		  
		  $(this).siblings().removeClass("active");
		  $(this).addClass("active");
		});
	}

	if($(".tab-switch-wrapper").length) switchTab();



});


